module.exports = __webpack_public_path__ + "img/meeting-26022025.0f890b0e.png";